/**
 * @module app.core
 */

import { autoinject } from 'aurelia-framework';
import { RouteConfig, NavigationInstruction } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';
import { ComponentBase } from 'app/shared/lib/essette-site';
import * as Core from 'app/core/models/essette-api';

@autoinject()
export class ImportJobSummaryPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    protected importJobStagedJobIdentifier: string | null = null;
    protected importJobStagedSystemCode: string | null = null;
    protected importJob: Core.ImportJob | null = null;


    ////****************** Element References ***************************************////



    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly i18n: I18N,
        ...rest: any[]) {

        super(...rest);
        this.logger.source = this;
    }

    protected async canActivate(params: any, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<boolean> {
        await this.accountContext.load();
        return this.accountContext.hasRouteAccess('core.imports.job.summary');
    }

    protected async activate(params: { systemCode: string, stagedJobIdentifier: string }, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<void> {
        if(!params?.systemCode || !params?.stagedJobIdentifier) {
            throw new Error('Missing required parameters: systemCode or stagedJobIdentifier');
        }

        this.importJobStagedSystemCode = params.systemCode;
        this.importJobStagedJobIdentifier = params.stagedJobIdentifier;

        if(this.importJobStagedJobIdentifier && routeConfig.navModel) {
            const title = this.i18n.tr('core:routes.imports.summary.$title', { display: this.importJobStagedJobIdentifier });
            routeConfig.navModel.setTitle(title);
        }
    }



    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////



    ////****************** Service Calls ********************************************////


}
